import type { TerrainSourceMode } from "./compiledterrain";

/**
 * Map source is intentionally selected at build time, not from URL parameters
 * or runtime configuration. Change this one value when comparing loaders.
 */
export const MAP_SOURCE_MODE = "legacy" as TerrainSourceMode;
